<template>
<div id="user-search">
  <search-form
    legend="Users"
    :label="label"
    :pageRef="$parent"
    :searchUrl="searchUrl"
    :filterByFeatured="filterByFeatured"
    :filterByStaff="filterByStaff"
  />
</div>
</template>
<script>
import SearchForm from '@/components/PagedSearchFieldForm'

export default {
  props: {
    filterByFeatured: {
      type: Boolean,
      default: false
    },

    filterByStaff: {
      type: Boolean,
      default: false
    },

    label: {
      type: String,
      default: undefined
    },

    userType: {
      type: String,
      default: 'users'
    }
  },

  computed: {
    searchUrl () {
      return this.apiUrl(`/${this.userType}/search`, true)
    }
  },

  components: {
    'search-form': SearchForm
  }
}
</script>



// WEBPACK FOOTER //
// src/components/UserSearch.vue